'use strict'
const previewFile = {
  path:'/preview',
  name:'app-preview',
  meta: {
    title: '',
    code:''
  },
  component: () => import('@/components/previewFile/PreviewFile'),
};

export default previewFile;